<template>
  <Modal v-if="activated"
         @close="doClose"
         :width="'620px'"
         :theme="'primary'"
  >
    <div slot="header">
      What did you expect ???
    </div>
    <div slot="body">
      <img src="@/assets/john.gif" alt="john travolta pulp fiction searching gif" />
    </div>
    <div slot="footer">
      <VButton :on-click="doClose">
        Close
      </VButton>
    </div>
  </Modal>
</template>
<script>
import VButton from './VButton'
import Modal from './Modal'

export default {
  name: 'Konami',
  components: { VButton, Modal },
  data() {
    return {
      activated: false,
      kode: ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
        'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
        'b', 'a'],
      pos: 0
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKey)
  },
  beforeDestroy() {
    document.removeEventListener('resize', this.handleKey)
  },
  methods: {
    doClose() {
      this.activated = false
    },
    handleKey(event) {
      if (event.key === this.kode[this.pos++]) {
        if (this.kode.length === this.pos) {
          this.activated = true
          this.pos = 0 // ability to start over
          return false
        }
      } else {
        this.pos = 0
      }
    }
  }
}
</script>
